/** Claim list/detail item with status used for mutation action guards. */
export interface ClaimMutationGuard {
  status?: string | null;
  canReset?: boolean;
}

export const CLAIM_MUTABLE_STATUS = "NOT_FILED";

/** True when claim mutation actions (snooze, deny, start case, pending post) are allowed. */
export function canMutateClaim(item: ClaimMutationGuard): boolean {
  return (item.status ?? "").toUpperCase() === CLAIM_MUTABLE_STATUS;
}

export function isClaimMutationDisabled(item: ClaimMutationGuard): boolean {
  return !canMutateClaim(item);
}

/** True when the claim status was changed from NOT_FILED and reset may apply. */
export function shouldShowClaimResetAction(item: ClaimMutationGuard): boolean {
  return !canMutateClaim(item);
}

/** True when POST /claims/{claimId}/reset is allowed for this claim. */
export function canResetClaim(item: ClaimMutationGuard): boolean {
  return item.canReset === true;
}

export function isClaimResetDisabled(item: ClaimMutationGuard): boolean {
  return !canResetClaim(item);
}

const RESOLUTION_TYPE_TRANSLATION_KEYS: Record<string, string> = {
  snooze: "claims.snooze",
  unclaimable: "claims.unclaimable",
  delivered: "claims.delivered",
  outside_date_range: "claims.outsideDateRange",
  reimbursed: "claims.reimbursed",
  not_eligible: "claims.notEligible",
  notEligible: "claims.notEligible",
};

/** Maps API resolutionType values to claims.* translation keys. */
export function getClaimResolutionTranslationKey(
  resolutionType: string,
): string {
  return (
    RESOLUTION_TYPE_TRANSLATION_KEYS[resolutionType] ??
    `claims.${resolutionType}`
  );
}
